import ds from 'designsystem';
import Header5 from 'elements/Header5';

const Header = Header5.extend`
  color: ${ds.brand('white')};
`;

export default Header;



// WEBPACK FOOTER //
// ./src/blocks/Footer/Header.jsx